"use client";

import Link, { type LinkProps } from "next/link";
import type { AnchorHTMLAttributes, ReactNode } from "react";

import { capturePostHogEvent } from "~/lib/posthog/client";

type HomepageEventName =
  | "homepage_cta_clicked"
  | "homepage_therapist_path_selected"
  | "homepage_therapist_profile_selected"
  | "homepage_need_selected";

type HomepageTrackedLinkProps = LinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & {
    children: ReactNode;
    event: HomepageEventName;
    eventProperties: Record<string, string>;
  };

export function HomepageTrackedLink({
  event,
  eventProperties,
  onClick,
  ...props
}: HomepageTrackedLinkProps) {
  return (
    <Link
      {...props}
      onClick={(clickEvent) => {
        capturePostHogEvent(event, eventProperties);
        onClick?.(clickEvent);
      }}
    />
  );
}
